import type {
  APIShareRegionalTrendItem,
  APIShareRegionalTrendResponse,
} from '@see-stella/types'

/**
 * Index a regional-trend response by scanId so the scan player can look up the
 * region dots for whatever scan the scrubber is on in O(1). Undefined trend (not
 * fetched yet / photos off) yields an empty map — the player falls back to the
 * profile's latest-scan regionalData until the trend arrives.
 */
export function regionalByScanId(
  trend: APIShareRegionalTrendResponse | undefined
): Map<string, APIShareRegionalTrendItem> {
  const byScanId = new Map<string, APIShareRegionalTrendItem>()
  if (!trend) return byScanId
  for (const item of trend.data) byScanId.set(item.scanId, item)
  return byScanId
}
